(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clothesline"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__hj)return;
    root.__hj=true;
    var track=root.querySelector(".hj-track");
    if(!track)return;
    var dataEl=root.querySelector(".hj-data"),DATA=[];
    try{DATA=JSON.parse(dataEl.textContent)}catch(e){DATA=[]}
    var reduce=root.dataset.reduceMotion==="true"||(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    var countEl=root.querySelector("[data-hj-count]"),hint=root.querySelector("[data-hj-hint]");
    var chips=[].slice.call(root.querySelectorAll(".hj-chip"));
    var MOOD_NAME={};chips.forEach(function(c){MOOD_NAME[c.dataset.m]=c.textContent.trim()});

    var items=[].slice.call(root.querySelectorAll(".hj-item")).map(function(li,i){
      return {li:li,btn:li.querySelector(".hj-hang"),sw:li.querySelector(".hj-swing"),fx:li.querySelector(".hj-focus"),rs:9,short:li.dataset.short||"",
        moods:(li.dataset.moods||"").split(" ").filter(Boolean),d:DATA[i]||{},
        a:0,v:0,ra:999,ph:i*1.7,amp:0.7+(i%3)*0.25,f:0.85+(i%4)*0.1,left:0,w:0};
    });

    function setCount(n){if(countEl)countEl.textContent=n+" "+(countEl.dataset.word||"styles")}
    setCount(items.length);

    function measure(){items.forEach(function(it){it.left=it.li.offsetLeft;it.w=it.li.offsetWidth})}
    measure();
    window.addEventListener("resize",measure);
    window.addEventListener("load",measure);

    /* Centre focus and caption */
    var focusOn=root.dataset.focus==="true",active=null;
    var cap=root.querySelector("[data-hj-caption]"),capBtn=cap&&cap.querySelector(".hj-cap-btn"),
        capName=cap&&cap.querySelector(".hj-cap-name"),capPrice=cap&&cap.querySelector(".hj-cap-price");
    function escH(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML}
    function renderCaption(){
      if(!cap||!active)return;
      var d=active.d;
      capName.textContent=active.short||d.title||"";
      capPrice.innerHTML="<b>"+escH(d.price)+"</b>"+(d.compare?"<s>"+escH(d.compare)+"</s>":"")+(d.off>0?"<em>"+d.off+"% off</em>":"");
      capBtn.setAttribute("aria-label",(d.title||"")+", "+(d.price||""));
      capBtn.classList.remove("hj-swap");void capBtn.offsetWidth;capBtn.classList.add("hj-swap");
    }
    function updateFocus(x){
      var vw=track.clientWidth,c=x+vw/2,best=null,bd=1e9;
      for(var j=0;j<items.length;j++){
        var it=items[j];if(it.li.hidden)continue;
        var d=Math.abs(it.left+it.w/2-c);
        if(d<bd){bd=d;best=it}
        if(focusOn){
          var f=Math.min(1,d/it.w),sc=1-0.12*f;
          if(Math.abs(sc-it.rs)>0.002){it.rs=sc;it.fx.style.transform="translateZ(0) scale("+sc.toFixed(4)+")";it.fx.style.opacity=(1-0.45*f).toFixed(3)}
        }
      }
      if(best!==active){active=best;renderCaption()}
    }
    if(capBtn)capBtn.addEventListener("click",function(){if(active)openSheet(active)});
    var fq=false;
    function queueFocus(){if(fq)return;fq=true;requestAnimationFrame(function(){fq=false;updateFocus(track.scrollLeft)})}

    /* Swing: damped spring per garment, driven by smoothed scroll speed, fixed small sub steps */
    var K=24,C=5.4,STEP=1/240;
    var px=track.scrollLeft,sv=0,lastT=0,running=false,visible=true,t0=performance.now();
    function kick(){if(!running&&!reduce&&visible&&!root.__dead){running=true;lastT=performance.now();requestAnimationFrame(step)}}
    function step(now){
      if(root.__dead){running=false;return}
      var dt=Math.min(0.05,Math.max(0,(now-lastT)/1000));lastT=now;
      var x=track.scrollLeft;
      if(dt>0){var vel=(x-px)/dt;sv+=(vel-sv)*Math.min(1,dt*9)}
      px=x;
      var drive=Math.max(-15,Math.min(15,-sv*0.0105));
      var t=(now-t0)/1000,vw=track.clientWidth,n=Math.max(1,Math.round(dt/STEP)),h=dt/n;
      for(var j=0;j<items.length;j++){
        var it=items[j];
        if(it.li.hidden)continue;
        var rel=it.left-x;
        if(rel>vw+40||rel+it.w<-40)continue;
        var target=Math.sin(t*1.05+it.ph)*it.amp+drive*it.f;
        for(var k=0;k<n;k++){it.v+=(-K*(it.a-target)-C*it.v)*h;it.a+=it.v*h}
        if(Math.abs(it.a-it.ra)>0.015){it.ra=it.a;it.sw.style.transform="translateZ(0) rotate("+it.a.toFixed(3)+"deg)"}
      }
      updateFocus(x);
      if(visible&&!reduce)requestAnimationFrame(step);else running=false;
    }
    track.addEventListener("scroll",function(){if(hint)hint.classList.add("hj-gone");if(reduce)queueFocus();else kick()},{passive:true});
    window.addEventListener("resize",queueFocus);
    queueFocus();
    if("IntersectionObserver" in window){
      new IntersectionObserver(function(es){visible=es[0].isIntersecting;if(visible)kick()}).observe(track);
    }
    kick();

    /* Mood filter */
    var busy=false;
    chips.forEach(function(c){c.addEventListener("click",function(){setMood(c.dataset.m)})});
    function setMood(m){
      if(busy)return;busy=true;
      chips.forEach(function(c){c.setAttribute("aria-pressed",c.dataset.m===m?"true":"false")});
      var shown=items.filter(function(it){return m==="all"||it.moods.indexOf(m)>-1});
      items.forEach(function(it){if(!it.li.hidden)it.li.classList.add("hj-leave")});
      setTimeout(function(){
        items.forEach(function(it,i){
          it.li.classList.remove("hj-leave");
          var on=shown.indexOf(it)>-1;it.li.hidden=!on;
          if(on){it.li.classList.remove("hj-enter");void it.li.offsetWidth;it.li.classList.add("hj-enter");it.a=0;it.v=(i%2?-1:1)*70}
        });
        track.scrollLeft=0;px=0;sv=0;
        measure();setCount(shown.length);active=null;queueFocus();kick();
        setTimeout(function(){items.forEach(function(it){it.li.classList.remove("hj-enter")});busy=false},520);
      },reduce?0:200);
    }

    /* Tap feedback */
    items.forEach(function(it,i){
      it.btn.addEventListener("pointerdown",function(){it.btn.classList.add("hj-lift");it.v+=(i%2?-1:1)*35;kick()});
      ["pointerup","pointerleave","pointercancel"].forEach(function(e){it.btn.addEventListener(e,function(){it.btn.classList.remove("hj-lift")})});
      it.btn.addEventListener("click",function(){openSheet(it)});
    });

    /* Bottom sheet */
    var sheet=root.querySelector(".hj-sheet"),scrim=root.querySelector(".hj-scrim"),lastFocus=null;
    var shImg=sheet.querySelector(".hj-sh-img"),shName=sheet.querySelector(".hj-sh-name"),shMoods=sheet.querySelector(".hj-sh-moods"),
        shPrice=sheet.querySelector(".hj-sh-price"),sizesWrap=sheet.querySelector(".hj-sizes-wrap"),sizesEl=sheet.querySelector(".hj-sizes"),
        view=sheet.querySelector(".hj-view");
    function esc(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML}
    // Move sheet to body so theme containers with transforms or overflow never trap it
    document.body.appendChild(scrim);document.body.appendChild(sheet);
    ["--hj-bg","--hj-accent","--hj-sheet-bg","--hj-sheet-text","--hj-btn-radius","--hj-heading-font","--hj-body-font"].forEach(function(v){
      var val=getComputedStyle(root).getPropertyValue(v);if(val){sheet.style.setProperty(v,val)}
    });

    function openSheet(it){
      var d=it.d;lastFocus=it.btn;
      shImg.src=d.img||"";shImg.alt=d.title||"";shImg.hidden=!d.img;
      shName.textContent=d.title||"";
      shMoods.innerHTML=it.moods.filter(function(m){return MOOD_NAME[m]}).map(function(m){return "<span>"+esc(MOOD_NAME[m])+"</span>"}).join("");
      shPrice.innerHTML="<b>"+esc(d.price)+"</b>"+(d.compare?"<s>"+esc(d.compare)+"</s>":"")+(d.off>0?"<em>"+d.off+"% off</em>":"");
      view.href=d.url||"#";
      sizesEl.innerHTML="";
      var sizes=d.sizes||[];
      sizesWrap.hidden=sizes.length===0;
      sizes.forEach(function(sz){
        var b=document.createElement("button");b.type="button";b.className="hj-size";b.textContent=sz.v;
        b.setAttribute("aria-pressed","false");if(!sz.a){b.dataset.soldout="true";b.setAttribute("aria-label",sz.v+", sold out")}
        b.addEventListener("click",function(){
          [].forEach.call(sizesEl.children,function(c){c.setAttribute("aria-pressed","false")});
          b.setAttribute("aria-pressed","true");
          view.href=(d.url||"#")+(sz.id?((d.url||"").indexOf("?")>-1?"&":"?")+"variant="+sz.id:"");
        });
        sizesEl.appendChild(b);
      });
      scrim.hidden=false;sheet.hidden=false;document.documentElement.style.overflow="hidden";
      requestAnimationFrame(function(){requestAnimationFrame(function(){scrim.classList.add("hj-open");sheet.classList.add("hj-open");view.focus({preventScroll:true})})});
    }
    function closeSheet(){
      scrim.classList.remove("hj-open");sheet.classList.remove("hj-open");document.documentElement.style.overflow="";
      setTimeout(function(){sheet.hidden=true;scrim.hidden=true;if(lastFocus)lastFocus.focus({preventScroll:true})},340);
    }
    scrim.addEventListener("click",closeSheet);
    sheet.querySelector(".hj-close").addEventListener("click",closeSheet);
    document.addEventListener("keydown",function(e){if(e.key==="Escape"&&!sheet.hidden)closeSheet()});
    var sy=null;
    sheet.addEventListener("touchstart",function(e){sy=e.touches[0].clientY},{passive:true});
    sheet.addEventListener("touchend",function(e){if(sy!==null&&e.changedTouches[0].clientY-sy>70&&sheet.scrollTop<=0)closeSheet();sy=null},{passive:true});

    root.__cleanup=function(){root.__dead=true;sheet.remove();scrim.remove();document.documentElement.style.overflow=""};
  }

  function boot(){[].forEach.call(document.querySelectorAll(".hj-cl"),init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
  document.addEventListener("shopify:section:load",function(e){init(e.target.querySelector(".hj-cl"))});
  document.addEventListener("shopify:section:unload",function(e){var r=e.target.querySelector(".hj-cl");if(r&&r.__cleanup)r.__cleanup()});
})();

  } catch(e) { console.error(e); }
})();
})();
